import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CoreTargetService } from '../core/services/target.service';
import { LocalStorageService } from '../core/services/local-storage.service';
import { HttpContext } from '@angular/common/http';
import { EXPECTS_CSV, USE_SEO_BASE } from '../core/http/http-context.tokens';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(
    private _http: HttpClient,
    private coreTargetService: CoreTargetService,
    private localStorageService: LocalStorageService,
  ) {}

  private allKeywordData = new BehaviorSubject<string | null>(null); // Initialize with null or default value
  allValue$ = this.allKeywordData.asObservable();

  setAllValue(value: string) {
    this.allKeywordData.next(value);
  }

  private keywordData = new BehaviorSubject<string | null>(null); // Initialize with null or default value
  value$ = this.keywordData.asObservable();

  setValue(value: string) {
    this.keywordData.next(value);
  }

  // selectedKeyword: any
  public selectedKeyword = new BehaviorSubject<string | null>(null);
  selectedValue$ = this.selectedKeyword.asObservable();

  updateSelectedObject(newObject: any) {
    this.selectedKeyword.next(newObject);
  }

  onboardNewTarget(data: any): Observable<any> {
    return this._http.post(`/onboard/new-target`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  addCompetitors(data: any): Observable<any> {
    return this._http.post(`/onboard/add-competitors`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  backlinksExtractSummary(url: string): Observable<any> {
    return this._http.post(
      `/backlinks/get-summary`,
      { url: url },
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  rawBacklinksExtract(url: string): Observable<any> {
    return this._http.post(
      `/backlinks/get-raw-backlinks`,
      { url: url },
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  extractPages(url: string): Observable<any> {
    return this._http.post(
      `/pages/extract-pages`,
      { url: url },
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  getPages(data: any): Observable<any> {
    return this._http.post(`/pages/get-pages`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getPagesMonth(data: any): Observable<any> {
    return this._http.post(`/content/get-pages-per-month`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getSummaryVariables(data: any): Observable<any> {
    return this._http.post(`/content/get-content-summary-variables`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getNewContentPage(data: any): Observable<any> {
    return this._http.post(`/content/new-content-page`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  removeKeywordFromDraft(data: any): Observable<any> {
    return this._http.post(`/content/remove-keyword-from-draft`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  addKeywordFromDraft(data: any): Observable<any> {
    return this._http.post(`/content/add-keyword-from-draft`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getProjects(): Observable<any> {
    return this._http.get(`/general/get-projects`, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  selectedTargetCompetitor(data: any): Observable<any> {
    return this._http.post(`/onboard/select-target-competitor`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getSelectedKeywords(data: any): Observable<any> {
    return this._http.post(`/keywords/select-keywords`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }

  extractOnPageFactors(data: any): Observable<any> {
    return this._http.post(`/factors/extract-onpage`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getOnPageFactors(data: any): Observable<any> {
    return this._http.post(`/factors/get-onpage`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  extractTechnicalFactors(data: any): Observable<any> {
    return this._http.post(`/factors/extract-technical`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getTechnicalFactors(data: any): Observable<any> {
    return this._http.post(`/factors/get-technical`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  extractBacklinkFactors(data: any): Observable<any> {
    return this._http.post(`/backlinks/extract-backlink-factors`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getBacklinkFactors(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-backlink-factors`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  extractSocialFactors(data: any): Observable<any> {
    return this._http.post(`/factors/extract-social`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getSocialFactors(data: any): Observable<any> {
    return this._http.post(`/factors/get-social`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  keywordAnalyzerAnalyzeKeyword(data: any): Observable<any> {
    return this._http.post(`/keywordanalyzer/analyze-keyword`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getKeywords(obj: any): Observable<any> {
    let tmpObj = JSON.parse(sessionStorage.getItem('selectedProject') || '{}');

    return this._http.post(
      `/keywords/get-analyzed-keywords`,
      {
        ...obj,
        country: tmpObj?.country,
      },
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  getAnalyse(obj: any) {
    return this._http.post(`/keywords/get-analyse`, obj, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getOrganicKeywords(data: any): Observable<any> {
    return this._http.post(`/keywords/get-related-keywords`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getOrganicKeywordsGrouped(data: any): Observable<any> {
    return this._http.post(`/keywords/get-related-keywords-grouped`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  extractRelatedKeywords(data: any): Observable<any> {
    return this._http.post(`/keywords/extract-related-keywords`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getUrlAnalyses(data: any): Observable<any> {
    return this._http.post(`/analyses/get-url-analyse`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getTechnicals(data: any): Observable<any> {
    return this._http.post(`/analyses/get-technical`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getOnPage(data: any): Observable<any> {
    return this._http.post(`/analyses/get-onpage`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getSocial(data: any): Observable<any> {
    return this._http.post(`/analyses/get-social`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getBacklinksList(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-backlinks-list`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getAnchors(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-anchors-list`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getReferringDomains(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-referring-domains`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getBacklinksAIProfile(data: any): Observable<any> {
    return this._http.post(`/backlinks/ai-profile`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getBacklinkInformation(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-backlink-information`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getBacklinkData(data: any): Observable<any> {
    return this._http.post(`/analyses/get-backlink-data`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  // old endpoint getAnalyseBacklinkValues(data: any, sort: string): Observable<any> {
  //   return this._http.post(
  //     `/backlinks/get-analyse-backlink-values?sort=${sort}`,
  //     data
  //   );
  // }
  getAnalyseBacklinkValues(data: any, sort: string): Observable<any> {
    return this._http.post(`/keywords/get-summary-values?sort=${sort}`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  measureRelevancy(data: any): Observable<any> {
    return this._http.post(`/analyses/measure-relevancy`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  saveKeywordsForAnalyse(data: any): Observable<any> {
    return this._http.post(`/keywords/save-keywords-for-analyse`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  createNewKeywordForAnalyse(data: any): Observable<any> {
    return this._http.post(`/keywords/create-new-keyword-for-analyse`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  onboardDeleteTarget(data: any): Observable<any> {
    return this._http.post(`/onboard/delete-target`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getProspectingBacklinks(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-prospecting-backlinks`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getRelatedKeywordsLandingPages(data: any): Observable<any> {
    return this._http.post(
      `/keywords/get-related-keywords-landing-pages`,
      data,
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  getKeywordsDateRangepositions(data: any): Observable<any> {
    return this._http.post(
      `/keywords/get-keywords-date-range-positions`,
      data,
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  serpUpdateRanking(data: any): Observable<any> {
    return this._http.post(`/serp/update-ranking`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  deleteAnalyse(data: any): Observable<any> {
    return this._http.post(`/keywords/delete-analyzed-keywords`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  deleteKeyword(data: any): Observable<any> {
    return this._http.post(`/keywords/delete-keyword`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  analysesAnalyseInformation(data: any): Observable<any> {
    return this._http.post(`/analyses/analyse-information`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  automationsOptimizationStatusChanger(data: any): Observable<any> {
    return this._http.post(`/automations/optimization-status-changer`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  automationsOnpageHealthChecker(data: any): Observable<any> {
    return this._http.post(`/automations/onpage-health-checker`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  automationsScriptStatus(data: any): Observable<any> {
    return this._http.post(`/automations/script-status`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  automationsUpdateAutomation(data: any): Observable<any> {
    return this._http.post(`/automations/update-automation`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getHtmlDrafts(data: any): Observable<any> {
    return this._http.post(`/content/get-content-drafts`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getDraftVersion(data: any): Observable<any> {
    return this._http.post(`/content/get-draft-version`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getRestoredDraft(data: any): Observable<any> {
    return this._http.post(`/content/restore-draft-version`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  deleteHtmlDraft(id: any): Observable<any> {
    return this._http.post(
      `/content/delete-draft`,
      {
        id: id,
      },
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  getHtmlData(url: any, domain: any, id: any): Observable<any> {
    return this._http.post(
      `/content/get-html`,
      {
        url: url,
        domain: domain,
        id: id,
      },
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  updateHtmlData(data: any): Observable<any> {
    return this._http.post(`/content/update-html`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  measureDraft(data: any): Observable<any> {
    return this._http.post(`/content/measure-draft`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  improveAll(data: any): Observable<any> {
    return this._http.post(`/content/automatically-update-content`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  improveAllChannels(data: any): Observable<any> {
    return this._http.post(
      `/content/automatically-update-content-for-all-channels`,
      data,
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  getKeywordsData(data: any): Observable<any> {
    return this._http.post(`/keywords/get-variables-summary`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getListOfPages(data: any): Observable<any> {
    return this._http.post(`/content/get-content-pages`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  addToPositionContent(data: any): Observable<any> {
    return this._http.post(`/keywords/save-keyword-content-for-analyse`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getContentChangeHistory(data: any): Observable<any> {
    return this._http.post(`/content/get-draft-versions`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }

  getSuggestionsForContent(data: any): Observable<any> {
    return this._http.post(`/content/suggest-relevant-content`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }

  getStatusOfProject(data: any): Observable<any> {
    return this._http.post(`/analyses/get-progress-of-bulk`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }

  uploadKeywordsCsv(formData: FormData, domain: string): Observable<any> {
    return this._http.post('/keywords/upload-csv', formData, {
      params: new HttpParams().set('domain', domain),
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  clusterKeywordsUploadCsv(
    formData: FormData,
    domain: string,
    selectedColum?: string,
    filename?: string,
  ): Observable<any> {
    if (selectedColum && filename) {
      return this._http.post(
        '/keywords/cluster-keywords-upload-csv',
        {
          filename: filename,
          column_selected: selectedColum,
        },
        {
          context: new HttpContext().set(USE_SEO_BASE, true),
        },
      );
    } else {
      const params = new HttpParams().set('domain', domain);

      return this._http.post(
        '/keywords/cluster-keywords-upload-csv',
        formData,
        { params, context: new HttpContext().set(USE_SEO_BASE, true) },
      );
    }
  }
  chooseMethodOfKeywords(data: any): Observable<any> {
    return this._http.post('/onboard/choose-method-of-keywords', data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getKeywordResearch(data: any): Observable<any> {
    return this._http.post(`/keywords/get-keyword-research`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  exportKeywordResearch(data: any): Observable<any> {
    return this._http.post(`/keywords/export-keyword-research`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true).set(EXPECTS_CSV, true),
    });
  }
  backlinksGetSuggestions(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-suggestions`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getSearchSuggestedTexts(data: any): Observable<any> {
    return this._http.post(`/keywords/get-suggestions`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  backlinksGetFinishedPredictions(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-finished-predictions`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  backlinksStartBacklinkPrediction(data: any): Observable<any> {
    return this._http.post(`/backlinks/start-backlink-prediction`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  backlinksDeleteFinishedPredictions(data: any): Observable<any> {
    return this._http.post(`/backlinks/delete-finished-predictions`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  backlinksGetFinishedAnalyse(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-finished-analyse`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  backlinksExportBacklinkPredictions(data: any): Observable<any> {
    return this._http.post(`/backlinks/export-backlink-predictions`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true).set(EXPECTS_CSV, true),
    });
  }
  backlinksUploadCSV(formData: FormData, domain: string): Observable<any> {
    const params = new HttpParams().set('domain', domain);

    return this._http.post(`/backlinks/backlinks-upload-csv`, formData, {
      params,
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getTasksAllTasks(data: any): Observable<any> {
    return this._http.post(`/tasks/all-tasks`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getCompetitors(data: any): Observable<any> {
    return this._http.post(`/competitors/get`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  removeCompetitors(data: any): Observable<any> {
    return this._http.post(`/competitors/remove`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  addCompetitorsPage(data: any): Observable<any> {
    return this._http.post(`/competitors/add`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  checkTaskFunction(data: any): Observable<any> {
    return this._http.post(`/tasks/check-task-status`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getContentScoresBins(data: any): Observable<any> {
    return this._http.post(`/content/get-content-scores-bins`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getStripeCustomer(data: any): Observable<any> {
    let params = new HttpParams();
    Object.keys(data).forEach((key) => {
      params = params.append(key, data[key]);
    });
    return this._http.get(`/stripe/get-customer`, {
      params,
    });
  }
  getStripeAllInvoices(data: any): Observable<any> {
    let params = new HttpParams();
    Object.keys(data).forEach((key) => {
      params = params.append(key, data[key]);
    });
    return this._http.get(`/stripe/all-invoices`, {
      params,
    });
  }
  getStripeCreateSubscription(data: any): Observable<any> {
    return this._http.post(`/stripe/create-subscription`, data);
  }
  getStripeCustomAllInvoices(data: any): Observable<any> {
    let params = new HttpParams();
    Object.keys(data).forEach((key) => {
      params = params.append(key, data[key]);
    });
    return this._http.get(`/custom-stripe/all-invoices`, {
      params,
    });
  }
  getStripeCustomCreateSubscription(data: any): Observable<any> {
    return this._http.post(`/custom-stripe/create-subscription`, data);
  }
  getStripeCustomCancelSubscription(data: any): Observable<any> {
    return this._http.post(`/custom-stripe/cancel-subscription`, data);
  }
  getStripeCustomUpdateSubscription(data: any): Observable<any> {
    return this._http.post(`/custom-stripe/update-subscription`, data);
  }
  getStripeUpdateSubscription(data: any): Observable<any> {
    return this._http.post(`/stripe/update-subscription`, data);
  }
  getStripeCancelSubscription(data: any): Observable<any> {
    return this._http.post(`/stripe/cancel-subscription`, data);
  }
  getStripeMemberships(packageId: any): Observable<any> {
    return this._http.get(`/stripe/memberships?packageId=${packageId}`);
  }
  getStripeUserSubscriptions(): Observable<any> {
    return this._http.get(
      `/stripe/user-subscriptions?target=${this.coreTargetService.getSelectedTarget(
        'target',
      )}&email=${this.localStorageService.get('email')}`,
    );
  }
  addExistingUrl(data: any): Observable<any> {
    if (data.formData) {
      return this._http.post(`/content/add-existing-url`, data.formData, {
        context: new HttpContext().set(USE_SEO_BASE, true),
      });
    } else {
      return this._http.post(`/content/add-existing-url`, data, {
        context: new HttpContext().set(USE_SEO_BASE, true),
      });
    }
  }
  recrawlExistingContent(data: any): Observable<any> {
    return this._http.post(`/content/recrawl-existing-content`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  integrationsGSCAuthUrl(): Observable<any> {
    return this._http.get(
      `/integrations/gsc/auth-url?returnTo=${location.href}`,
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  integrationsGSCProperties(domain: string): Observable<any> {
    return this._http.get(`/integrations/gsc/properties?domain=${domain}`, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  integrationsGSCRegions(data: any): Observable<any> {
    return this._http.post(`/integrations/gsc/regions`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  integrationsGSCKeywordsStats(data: any): Observable<any> {
    return this._http.post(`/integrations/gsc/keywordsStats`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  integrationsGSCKeywordSelection(data: any): Observable<any> {
    return this._http.post(`/integrations/gsc/keyword-selection`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  integrationsGSCIntegrated(): Observable<any> {
    return this._http.get(`/integrations/gsc/integrated`, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  keywordsGetOverviewTasks(data: any): Observable<any> {
    return this._http.post(`/keywords/get-overview-tasks`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  keywordsClusterKeywords(data: any): Observable<any> {
    return this._http.post(`/keywords/cluster-keywords`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  generalTestUrl(data: any): Observable<any> {
    return this._http.post(`/general/test-url`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getRankingKeywordsForUrl(data: any): Observable<any> {
    return this._http.post(`/content/get-ranking-keywords-for-url`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  deletePage(data: any): Observable<any> {
    return this._http.post(`/content/delete-page`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  recrawlTarget(data: any): Observable<any> {
    return this._http.post(`/onboard/recrawl-target`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getSuggestRelevantInternalLinks(data: any): Observable<any> {
    return this._http.post(`/content/suggest-relevant-internal-links`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  generateNewContent(data: any): Observable<any> {
    return this._http.post(`/content/generate-new-content`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  integrateWordpress(data: any): Observable<any> {
    return this._http.post(`/integrations/wordpress/integrate`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getWordpressIntegration(data: any): Observable<any> {
    return this._http.post(`/integrations/wordpress/get-integration`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  publishContent(data: any): Observable<any> {
    return this._http.post(`/integrations/wordpress/publish-content`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getSiteLevelPrompt(data: any): Observable<any> {
    return this._http.post(`/general/get-site-level-prompt`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  createSiteLevelPrompt(data: any): Observable<any> {
    return this._http.post(`/general/create-site-level-prompt`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  createContentSuggestions(data: any): Observable<any> {
    return this._http.post(`/integrations/gsc/new-content-suggestions`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  integrationsGSCLogout(domain: string): Observable<any> {
    return this._http.get(`/integrations/gsc/logout?domain=${domain}`, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  integrationsGSCSaveConfig(data: any): Observable<any> {
    return this._http.post(`/integrations/gsc/saveConfig`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  recrawlBacklinks(data: any): Observable<any> {
    return this._http.post(`/onboard/recrawl-backlinks`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  addCustomBacklinks(data: any): Observable<any> {
    return this._http.post(`/onboard/add-custom-backlinks`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getKeywordData(data: string): Observable<any> {
    return this._http.post(
      `/general/get-keywords-left`,
      {
        domain: data,
      },
      {
        context: new HttpContext().set(USE_SEO_BASE, true),
      },
    );
  }
  addKeywordPipelines(formData: FormData, domain: string): Observable<any> {
    const params = new HttpParams().set('domain', domain);
    return this._http.post('/content/add-keyword-pipelines', formData, {
      params,
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getKeywordPipelines(data: any): Observable<any> {
    return this._http.post(`/content/get-keyword-pipelines`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  deleteKeywordPipeline(data: any): Observable<any> {
    return this._http.post(`/content/delete-keyword-pipeline`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getBacklinkScoresBins(data: any): Observable<any> {
    return this._http.post(`/backlinks/get-backlink-scores-bins`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  createShareableToken(data: any): Observable<any> {
    return this._http.post(`/general/create-shareable-token`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  downloadClustering(data: any): Observable<any> {
    return this._http.post(`/keywords/export-keyword-clustering`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true).set(EXPECTS_CSV, true),
    });
  }
  getInvoicePDF(invoiceId: string, target: string): Observable<any> {
    return this._http.get(
      `/custom-stripe/get-invoice-pdf?invoiceId=${invoiceId}&target=${target}`,
    );
  }
  getOrganicTraffic(data: any): Observable<any> {
    return this._http.post(`/analyses/get-organic-traffic`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  uploadKeywordsCSV(formData: FormData, domain: string): Observable<any> {
    const params = new HttpParams().set('domain', domain);

    return this._http.post(`/keywords/upload-keywords-csv`, formData, {
      params,
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
  getCompetitorSummary(data: any): Observable<any> {
    return this._http.post(`/keywords/get-competitor-summary`, data, {
      context: new HttpContext().set(USE_SEO_BASE, true),
    });
  }
}
